import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autoDismiss: { type: Boolean, default: false } }

  connect() {
    if (!this.autoDismissValue) return

    const isPersistent = this.element.classList.contains("toast-error") ||
                         this.element.classList.contains("toast-warning")
    const delay = isPersistent ? 8000 : 4000

    this.element.addEventListener("mouseenter", () => this.pause())
    this.element.addEventListener("mouseleave", () => this.resume(delay))
    this.scheduleDismiss(delay)
  }

  scheduleDismiss(delay) {
    this.timeout = setTimeout(() => this.dismiss(), delay)
  }

  pause() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  resume(delay) {
    this.scheduleDismiss(delay)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "translate-x-4")
    setTimeout(() => this.element.remove(), 300)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}